import React from 'react';
import { ChevronLeft, ChevronRight, MoveHorizontal } from 'lucide-react';

export default function MobileCarouselControls({ targetId }) {
  const move = (direction) => {
    const track = document.getElementById(targetId);
    if (!track) return;
    track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
    window.setTimeout(() => {
      const cards = [...track.querySelectorAll(':scope > article')];
      if (!cards.length) return;
      const trackCenter = track.getBoundingClientRect().left + track.clientWidth / 2;
      const activeCard = cards.reduce((closest, card) => {
        const bounds = card.getBoundingClientRect();
        const distance = Math.abs(bounds.left + bounds.width / 2 - trackCenter);
        return !closest || distance < closest.distance ? { card, distance } : closest;
      }, null)?.card;
      cards.forEach((card) => card.classList.remove('carousel-card-active'));
      if (activeCard) {
        void activeCard.offsetWidth;
        activeCard.classList.add('carousel-card-active');
      }
    }, 360);
  };

  return (
    <div className="mobile-carousel-controls" aria-label="Commandes du carrousel">
      <button type="button" onClick={() => move(-1)} aria-label="Afficher l’élément précédent"><ChevronLeft /></button>
      <span><MoveHorizontal /> Faites défiler</span>
      <button type="button" onClick={() => move(1)} aria-label="Afficher l’élément suivant"><ChevronRight /></button>
    </div>
  );
}
